window.addEventListener('DOMContentLoaded', () => {
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.querySelector('header');
    var topBanner = document.getElementById('top-banner');

    var checkScroll = function () {
        /*
         ** Find the direction of scroll
         ** 0 - initial, 1 - up, 2 - down
         */
        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll > prevScroll) {
            //scrolled down
            direction = 2;
        } else if (curScroll < prevScroll) {
            //scrolled up
            direction = 1;
        }

        if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
        }

        prevScroll = curScroll;

        if (header.classList.contains("header-wizard")) {
            header.classList[curScroll > 0 ? 'add' : 'remove']('scrolling');
        }
    };

    var toggleHeader = function (direction, curScroll) {
        var headerHeight = header.offsetHeight;
        if (direction === 2 && curScroll > headerHeight) {
            header.classList.add('hide');
            if (topBanner) {
                topBanner.classList.add('hide');
            }
            prevDirection = direction;
        } else if (direction === 1) {
            header.classList.remove('hide');
            if (topBanner) {
                topBanner.classList.remove('hide');
            }
            prevDirection = direction;
        }
    };

    w.addEventListener('scroll', checkScroll);
});
